<template>
  <div v-if="active">
    <slot></slot>
  </div>
  <div v-else>
    <input type="hidden" :name="hiddenInputName" value="" />
  </div>
</template>

<script>
export default {
  props: {
    inputValue: null,
    inputName: String,
    showIfNoValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      conditionalValue: null,
      hiddenInputName: this.name,
    };
  },

  computed: {
    // Calculate if the component is hidden or visible
    active() {
      if (this.conditionalValue) {
        return (
          this.conditionalValue === this.inputValue ||
          (Array.isArray(this.inputValue) &&
            this.inputValue.includes(this.conditionalValue))
        );
      } else {
        return this.showIfNoValue;
      }
    },
  },

  methods: {
    // Update the conditonal value on which we are basing the visibility of the input
    updateConditionalValue(value) {
      this.conditionalValue = value;
    },
  },

  mounted() {
    // Get the form which this element belongs to
    let form = this.$el.closest('form');

    // Add an event listener to watch the target input ( the name of the input must be unique within the form )
    let conditionalInput = form.elements[this.inputName];

    if (conditionalInput) {
      this.conditionalValue = conditionalInput.value;
      // If it radio, we need to add a even listener to each node
      if (conditionalInput.length && conditionalInput[0].type == 'radio') {
        conditionalInput.forEach(($input) =>
          $input.addEventListener('change', (event) =>
            this.updateConditionalValue(event.target.value)
          )
        );
      } else {
        conditionalInput.addEventListener('change', (event) =>
          this.updateConditionalValue(event.target.value)
        );
      }
    }
  },
};
</script>

<style></style>
